module.exports = __webpack_public_path__ + "img/logo.ed52a39b.png";